<template>
  <router-link to="/">
    <img src="@/assets/img/logo.png" class="w-32" alt="Shuttlers" />
    <div class="font-medium text-center uppercase" style="font-size: 8px;">For businesses</div>
  </router-link>
</template>